import React from 'react';

import { Grid } from '@material-ui/core';
import { StyledAvatar } from 'components/avatars';
import styled from 'styled-components';
import { StyledBox, StyledPaper, StyledTypography } from 'styles/common';

import {
  CONTINUOUS_FEEDBACK_FORM_STATUS,
  CONTINUOUS_FEEDBACK_PEER_STATUS,
  FEEDBACK_FORM_TYPE,
  FEEDBACK_FORM_VISIBILITY,
} from 'constants/ProjectConstants';
import {
  PublicViewIcon,
  PrivateViewIcon,
  PrivateManagerViewIcon,
  ManagerViewIcon,
  StyledIcon,
  CheckIcon,
  HourglassIcon,
  CloseIcon,
  SendTiltedIcon,
} from 'constants/icons';

import DateComp from 'uiToolkit/DateComp';

const IconPack = {
  PUBLIC: <PublicViewIcon />,
  NONE: <PrivateViewIcon />,
  RECEIVER: <PrivateViewIcon />,
  MANAGER: <PrivateManagerViewIcon />,
  RECEIVER_AND_MANAGER: <ManagerViewIcon />,
};

const PeerStatusIconPack = {
  NOMINATED: <SendTiltedIcon />,
  ACCEPTED: <HourglassIcon />,
  DECLINED: <CloseIcon />,
  SUBMITTED: <CheckIcon />,
};

const StyledGrid = styled(Grid)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const FeedbackListRowView = ({ employee, review, handleClick, type }) => {
  const reviewStatus = () => {
    const { peerStatus } = review;
    switch (peerStatus) {
      case CONTINUOUS_FEEDBACK_PEER_STATUS.NOMINATED:
        return 'Requested';
      case CONTINUOUS_FEEDBACK_PEER_STATUS.ACCEPTED:
        return 'Pending';
      case CONTINUOUS_FEEDBACK_PEER_STATUS.DECLINED:
        return 'Declined';
      default:
        return null;
    }
  };
  return (
    <StyledBox
      display="flex"
      flexDirection="column"
      padding="0.8rem 0"
      clickable
      onClick={() =>
        handleClick({
          formType: review.feedbackType,
          feedbackId: review.id,
        })
      }
    >
      <Grid container>
        <Grid item sm={5}>
          <StyledPaper elevation={0} flexcontainer alignitems="center">
            <StyledAvatar src={employee?.profilePhoto} size="smaller" />
            <StyledTypography weight="bold" variant="body1" component="div" leftGutter={2}>
              {employee?.displayName}
            </StyledTypography>
          </StyledPaper>
        </Grid>
        <StyledGrid item sm={4}>
          <StyledPaper elevation={0} flexcontainer alignitems="center">
            {type === FEEDBACK_FORM_TYPE.REQUESTED ? (
              <>
                <StyledIcon size="header" color="grey">
                  {review.submissionStatus === CONTINUOUS_FEEDBACK_FORM_STATUS.COMPLETED
                    ? PeerStatusIconPack[review.submissionStatus]
                    : PeerStatusIconPack[review.peerStatus]}
                </StyledIcon>
                <StyledTypography variant="body1" component="div" leftGutter={1} color="grey">
                  {review.submissionStatus === CONTINUOUS_FEEDBACK_FORM_STATUS.COMPLETED ? 'Received' : reviewStatus()}
                </StyledTypography>
              </>
            ) : (
              <>
                <StyledIcon size="header" color="grey">
                  {IconPack[review.visibility]}
                </StyledIcon>
                <StyledTypography variant="body1" component="div" leftGutter={1} color="grey">
                  {FEEDBACK_FORM_VISIBILITY.filter((item) => item.value === review.visibility)[0].label}
                </StyledTypography>
              </>
            )}
          </StyledPaper>
        </StyledGrid>
        <Grid item container sm={3} alignItems="center">
          {review.submissionDateFormatted && (
            <DateComp
              tooltip="Submitted on"
              editable={false}
              startDateTime={review.submissionDateFormatted.timeStamp}
              color={review.submissionDateFormatted.color}
              isCrossed={review.submissionDateFormatted.isCrossed}
            />
          )}
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default FeedbackListRowView;
